module.exports = __webpack_public_path__ + "img/pdf.c1ae6d25.png";